import dynamic from "next/dynamic";
import Head from "next/head";
import { handleRateLimit } from "utils/handleRateLimit";

const SearchWrapper = dynamic(() => import("@components/Components/Search/SearchWrapper"), { ssr: false });

const route = () => {
    return (
        <>
            <Head>
                <title>{`Search - ${process.env.brand.brand_name}`}</title>
                <meta name="robots" content="noindex" />
            </Head>
            <SearchWrapper />
        </>
    );
};

export async function getServerSideProps({ res, query }) {
    // The term is never in the address: it is kept in the page's state and the session, so a link with one goes to the clean address.
    if (query?.term) {
        return {
            redirect: {
                destination: '/search',
                permanent: false,
            },
        };
    }

    try {
        const req = await fetch(`${process.env.BASE_API_URL}get-search-settings`);
        const data = await req.json();

        const rateLimitRedirect = handleRateLimit(res, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (data.status === 'failed' || data.exception) {
            return { notFound: true };
        }

        return {
            props: {
                data,
            },
        };
    } catch (error) {
        return {
            props: {},
        };
    }
}

export default route;
